import React, { useState, useEffect } from "react";
import Profile from "../../assets/images/profileImage.jpg";
import LeftArrowIcon from "../../assets/svg/LeftArrowIcon.svg";
import Header from "../../components/Header/Header";
import ScrollToTop from "../../components/Hooks/ScrollToTop";
import styles from "./BlockedUser.module.scss";
import { useNavigate } from "react-router";
import SmallHeader from "../../components/Small_Header/SmallHeader";
import { FaAngleLeft } from "react-icons/fa6";
import { useSelector } from "react-redux";
import axios from "../../components/Hooks/axios";
import { toast } from "react-toastify";
import moment from "moment";
import DefaultProfilePic from "../../assets/images/user.png";

const BlockedUser = () => {
	const navigate = useNavigate();
	const { userId } = useSelector((state) => state.auth);
	const [blockedUsers, setBlockedUsers] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

	const fetchBlockedUsers = async () => {
		setIsLoading(true);
		try {
			const { data } = await axios.get("/auth/blocked-users");
			setBlockedUsers(data.data || []);
		} catch (error) {
			console.error("Failed to fetch blocked users", error);
			// toast.error("Failed to load blocked users");
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		fetchBlockedUsers();
	}, [userId]);

	const handleUnblock = async (targetId) => {
		try {
			const { data } = await axios.post("/auth/block-unblock-user", {
				user_id: targetId,
				type: "unblock"
			});
			toast.success(data.message);
			// Remove from local state
			setBlockedUsers(prev => prev.filter(item => item.block_user._id !== targetId));
		} catch (error) {
			toast.error(error.response?.data?.message || "Unblock failed");
		}
	};

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 1024);
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return (
		<div className="App">
			<div className="MainContainer">
				<ScrollToTop />
				<Header />

				{isMobile ? <SmallHeader /> : null}
				<div className={`${styles.Container} ${styles.BlockedUser}`}>
					<div className={styles.BackButton}>
						<button
							onClick={() => {
								navigate(-1);
							}}>
							<FaAngleLeft />
						</button>
					</div>
					<div className={styles.BlockedUserCont}>
						{isMobile ? null : (
							<div className={styles.LeftBlockedUserContainer}>
								<h1 className={styles.BlockedUserText}>Blocked User</h1>
								<h3 className={styles.BlockedUserDetail}>List of all the account that you have blocked</h3>
								<div className={styles.BlockedUserSearch}>
									{blockedUsers.length > 0 ? (
										blockedUsers.map((item, index) => (
											<div key={item._id} className={styles.BlockUserBox}>
												<div className={styles.BlockBoxLeft}>
													<img
														src={item.block_user?.ProfilePic || DefaultProfilePic}
														onError={(e) => { e.target.src = DefaultProfilePic; }}
														alt=""
													/>
													<div>
														<h5>{item.block_user?.username}</h5>
														<p>U have blocked on {moment(item.createdAt).format("DD - MMM")}</p>
													</div>
												</div>
												<button type="button" onClick={() => handleUnblock(item.block_user?._id)}>
													Unblock
												</button>
											</div>
										))
									) : (
										<p style={{ color: 'white', padding: '20px', textAlign: 'center' }}>
											{isLoading ? "Loading..." : "No users blocked"}
										</p>
									)}
								</div>
							</div>
						)}

						<div className={styles.RightBlockedUserContainer}>
							{/* {isMobile ? null : (
								<div className={styles.LeftArrow} onClick={() => navigate(-1)}>
									<img src={LeftArrowIcon} alt="" />
								</div>
							)} */}

							<h1 className={styles.Note}>Note</h1>
							<p className={styles.NoteText}>
								Once you blocked someone they will no longer to see things that you post on your feed , tag you ,
								invite you or start a conversation with you. However you can unblock them later if you want{" "}
							</p>
							<h1 className={styles.BlockedPagesText}></h1>

							<div className={styles.BlockPageContainer}>
								{blockedUsers.length > 0 ? (
									blockedUsers.map((item, index) => (
										<div key={item._id} className={styles.BlockUserBox}>
											<div className={styles.BlockBoxLeft}>
												<img
													src={item.block_user?.ProfilePic || DefaultProfilePic}
													onError={(e) => { e.target.src = DefaultProfilePic; }}
													alt=""
												/>
												<div>
													<h5>{item.block_user?.username}</h5>
													<p>U have blocked on {moment(item.createdAt).format("DD - MMM")}</p>
												</div>
											</div>
											<button
												type="button"
												onClick={() => handleUnblock(item.block_user?._id)}
												className={styles.blockedStatusButton}>
												Unblock
											</button>
										</div>
									))
								) : (
									<p style={{ color: 'white', padding: '20px', textAlign: 'center' }}>
										{isLoading ? "Loading..." : "No users blocked"}
									</p>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BlockedUser;


